
export default function LoadingPage() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gradient-to-br from-purple-200 to-purple-300 dark:from-gray-900 dark:to-gray-800 overflow-hidden">
      <div className="text-center relative w-full max-w-md">
        <div className="flex justify-center mb-6">
          <img
            src="/images/AI.png"
            alt="Loading..."
            className="w-72 h-72 object-cover animate-bounce rounded-full shadow-lg "
          />
        </div>

        <div className="space-y-4">
          <h1 className="text-3xl font-bold text-gray-800 dark:text-white animate-pulse">
            Loading
          </h1>
          <p className="text-gray-600 dark:text-gray-300 animate-bounce">
            Hop hop! Content is on its way...
          </p>
        </div>
      </div>
    </div>
  );
}